<template>
    <div class="sustainable-component wage-evaluate-analysis">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-evaluate-analysis</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col-12 col-md-6">
                    <v-form>
                        <v-checkbox label="Riktarbete" v-model="referencePosition"></v-checkbox>
                    </v-form>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, i) in factorAnalysis.Factors" class="col-md-4 mb-3" :key="i">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Faktor {{item.Name}}</h5>
                            <div class="card-text">
                                <table>
                                    <tr>
                                        <th class="col-8">Befattning</th>
                                        <th class="col-4">Poäng</th>
                                    </tr>
                                    <tr v-for="(wageFactorPoint, x) in item.WageFactorPoints" :key="x">
                                        <td v-if="wageFactorPoint.JobPositionId == selectedPosition"><b>{{wageFactorPoint.Name}}</b></td>
                                        <td v-if="wageFactorPoint.JobPositionId != selectedPosition">{{wageFactorPoint.Name}}</td>
                                        <td v-if="wageFactorPoint.JobPositionId == selectedPosition"><b>{{wageFactorPoint.Points}}</b></td>
                                        <td v-if="wageFactorPoint.JobPositionId != selectedPosition">{{wageFactorPoint.Points}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Summa alla faktorer</h5>
                            <div class="card-text">
                                <table>
                                    <tr>
                                        <th class="col-8">Befattning</th>
                                        <th class="col-4">Poäng</th>
                                    </tr>
                                    <tr v-for="(item, i) in factorAnalysis.WageFactorSumPoints" :key="i">
                                        <td v-if="item.JobPositionId == selectedPosition"><b>{{item.Name}}</b></td>
                                        <td v-if="item.JobPositionId != selectedPosition">{{item.Name}}</td>
                                        <td>{{item.Points}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="getAnalysis">
                        Uppdatera
                    </v-btn>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'wage-evaluate-analysis',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            
            getId() {
                return getCurrentInstance().uid;
            },
            async getAnalysis() {
                this.loading++;
                try {
                    this.factorAnalysis = await WageService.getFactorAnalysis(this.selectedPosition, this.referencePosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                referencePosition: false,
                selectedPosition: null,
                factorAnalysis: {
                    Factors: [],
                    WageFactorSumPoints: [],
                },
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            referencePosition: function () {
                this.getAnalysis();
            },
            selectedPosition: function(newVal) {
                this.getAnalysis();
                this.$emit('positionSelected', newVal)
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
